import { Link } from "react-router-dom";

interface OrderSuccessProps {
  email: string;
  orderNumber: string;
}

export default function OrderSuccess({ email, orderNumber }: OrderSuccessProps) {
  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-4" style={{ fontFamily: "'Jost', sans-serif" }}>
      <div className="w-full max-w-md text-center">
        {/* Success Icon */}
        <div className="w-20 h-20 rounded-full bg-midnight flex items-center justify-center mx-auto mb-8">
          <i className="ri-check-line text-3xl text-moonlight" />
        </div>

        {/* Heading */}
        <h1
          className="text-3xl font-light text-midnight mb-3"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Order Confirmed
        </h1>
        <p className="text-sm text-midnight/50 leading-relaxed mb-2">
          Thank you! Your order has been placed successfully.
        </p>
        <p className="text-xs text-midnight/40 mb-6">
          A confirmation has been sent to <span className="text-midnight font-medium">{email}</span>
        </p>

        {/* Order Number */}
        <div className="bg-white border border-pearl/60 rounded-lg px-6 py-5 mb-8">
          <p className="text-[10px] tracking-widest uppercase text-midnight/40 mb-2">Order Number</p>
          <p className="text-2xl font-light text-midnight tracking-widest" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {orderNumber}
          </p>
        </div>

        {/* What's next */}
        <div className="text-left mb-8 space-y-3">
          {[
            { icon: "ri-mail-line", title: "Check your email", desc: "Order confirmation & receipt sent to your inbox" },
            { icon: "ri-truck-line", title: "Shipping updates", desc: "We'll notify you when your order ships" },
            { icon: "ri-map-pin-line", title: "Track your order", desc: "Tracking link will be emailed once dispatched" },
          ].map((step) => (
            <div key={step.title} className="flex items-start gap-3 bg-white border border-pearl/40 rounded-lg px-4 py-3">
              <div className="w-8 h-8 flex items-center justify-center shrink-0 mt-0.5">
                <i className={`${step.icon} text-base text-midnight/40`} />
              </div>
              <div>
                <p className="text-xs font-medium text-midnight mb-0.5">{step.title}</p>
                <p className="text-[11px] text-midnight/40">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <Link
          to="/"
          className="w-full block py-4 bg-midnight text-moonlight text-xs tracking-widest uppercase hover:bg-midnight/90 transition-colors cursor-pointer whitespace-nowrap rounded"
        >
          Continue Shopping
        </Link>
        <Link
          to="/order-tracking"
          className="w-full block mt-3 py-4 border border-pearl text-midnight text-xs tracking-widest uppercase hover:border-midnight/40 transition-colors cursor-pointer whitespace-nowrap rounded"
        >
          Track Your Order
        </Link>
      </div>
    </div>
  );
}
